export default class AccountDropdown {
  constructor() {
    this.headerAccount = document.querySelector('.header__icon--account');
    this.dropdownOverlay = document.querySelector('.account-dropdown--overlay');
    this.dropdown = document.querySelector('.header__account-dropdown');

    this.clickHandler = this.toggleDropdown.bind(this);
    this.mouseOverHandler = this.mouseOver.bind(this);
    this.mouseOutHandler = this.mouseOut.bind(this);

    this.init();
    window.addEventListener('resize', this.init.bind(this));
  }

  toggleDropdown(event) {
    const activeDropdown = document.querySelector('.header__account-dropdown.open');
    if (this.headerAccount.contains(event.target) && !activeDropdown) {
      this.dropdownOverlay.classList.toggle('open');
      document.documentElement.classList.toggle('overflow-hidden');
      this.dropdown.classList.toggle('open');
    }

    if (activeDropdown && !activeDropdown.contains(event.target)) {
      this.dropdownOverlay.classList.remove('open');
      document.documentElement.classList.remove('overflow-hidden');
      this.dropdown.classList.remove('open');
    }
  }

  mouseOver() {
    this.dropdownOverlay.classList.add('open');
  }

  mouseOut() {
    this.dropdownOverlay.classList.remove('open');
  }

  init() {
    if (window.innerWidth <= 1099) {
      document.addEventListener('click', this.clickHandler);
      this.headerAccount.removeEventListener('mouseover', this.mouseOverHandler);
      this.headerAccount.removeEventListener('mouseout', this.mouseOutHandler);
    } else {
      document.removeEventListener('click', this.clickHandler);
      this.headerAccount.addEventListener('mouseover', this.mouseOverHandler);
      this.headerAccount.addEventListener('mouseout', this.mouseOutHandler);
    }
  }
}
